import { genBasicStore } from '../vuex'
import assign from 'lodash/assign'
import axios from 'axios'

const store = genBasicStore('oem')

assign(store.actions, {
  async find_one ({ commit }, name) {
    const http = axios.create({ baseURL: process.env.VUE_APP_API_HOST.replace(/\/fresh_chain_admin$/, '') })
    const res = await http.get('/oem', { params: { name } })
    if (res.data.data) {
      commit('setRecord', res.data.data)
    } else {
      console.log('%cOEM信息不存在', 'color:red;font-size:30px;font-weight:bold;')
    }
  }
})

export default store
